import { Result, Schema } from 'effect';
import { PositiveIntegerFromString, PositiveNumberFromString } from '../../../domain/positions';

/**
 * What the text typed into a position's fields reads as, for every row a position is typed into: the row that creates one and the row that edits one.
 *
 * The rules themselves live with the positions they describe, so a row cannot come to allow something the API would refuse. What is here is only the reading of a field's text by them.
 */

const decodeCountable = Schema.decodeResult(PositiveIntegerFromString);

const decodePositionNumber = Schema.decodeResult(PositiveNumberFromString);

/** The quantity, height or width the text reads as, or null when it reads as none. */
export function toCountable(text: string): number | null {
	return Result.getOrNull(decodeCountable(text));
}

/**
 * The place in the list the text reads as, or null when it reads as none.
 *
 * Not a whole number, unlike a quantity: positions are put between each other, so 1.1 sits between 1 and 2. Below the first place is the one thing it cannot be.
 */
export function toPositionNumber(text: string): number | null {
	return Result.getOrNull(decodePositionNumber(text));
}
